import './RevenueWrapper.scss';
import React, { useState, useEffect, useContext } from 'react';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Dropdown, message, Space, Tooltip } from 'antd';
import DatePicker from '../calendar/DatePicker';
import axios from 'axios';
import Revenue from './Revenue';

import { getLocalCurrentDateTime, getLocalDateTime7DaysAgo } from 'app/shared/util/date-utils';
import { APP_LOCAL_DATETIME_FORMAT } from 'app/config/constants';
import dayjs from 'dayjs';
import { OrganizationsContext } from 'app/store/OrganizationContext';

const RevenueWrapper = (props = {}) => {
  const initialDate = {
    fromDateTime: getLocalDateTime7DaysAgo(),
    toDateTime: getLocalCurrentDateTime(),
  };

  const [customerSelectedDate, setUserSelectedDate] = useState(initialDate);

  const { selectedOrganizationId } = useContext(OrganizationsContext);

  const handleOnDateChange = (date, dateStr) => {
    const { fromDateTime: selectedFromDateTime, toDateTime: selectedToDateTime } = customerSelectedDate;
    const [fromDateTime, toDateTime] = dateStr;

    if (fromDateTime === selectedFromDateTime && toDateTime === selectedToDateTime) return;
    setUserSelectedDate({ fromDateTime, toDateTime });
  };

  return (
    <main className="revenue-page">
      <section className="calender-wrapper">
        <DatePicker
          onChange={handleOnDateChange}
          defaultValue={[
            dayjs(getLocalDateTime7DaysAgo(), APP_LOCAL_DATETIME_FORMAT),
            dayjs(getLocalCurrentDateTime(), APP_LOCAL_DATETIME_FORMAT),
          ]}
        />
      </section>
      {selectedOrganizationId && selectedOrganizationId.length > 0 && (
        <section className="charts-section">
          <Revenue customerSelectedDate={customerSelectedDate} selectedOrganizationId={selectedOrganizationId} />
        </section>
      )}
    </main>
  );
};

export default RevenueWrapper;
